module.exports = __webpack_public_path__ + "img/check-badge.c2b92eb2.svg";